import axios, { AxiosError, Method } from 'axios';
import ApiServiceError from 'support/ApiServiceError';
import { HttpOptions } from 'services/CwApiClient';
import { AppData } from '@lightningjs/sdk';

export enum Endpoints {
  CONTINUE_WATCHING = '/continue-watching',
  CONTINUE_WATCHING_CONTENT = '/continue-watching/content',
  CONTINUE_WATCHING_CONTENT_GROUP = '/continue-watching/content-group',

  WATCHLIST_SHOWS = '/watchlist/shows',
  WATCHLIST_SHOWS_CONTENT_GROUP = '/watchlist/shows/content-group',

  FAVORITE_CHANNELS = '/watchlist/channels',
  FAVORITE_CHANNELS_CHANNEL = '/watchlist/channels/channel',

  LOGIN_SOTT = '/login/sott/device/smart-tv',
  ACCESS_TOKEN_REFRESH = '/login/refresh/device/smart-tv',
}

export default class PersonaApiClient {
  async request<TResponse = unknown>(
    method: Method,
    url: string,
    options?: HttpOptions,
  ) {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...options?.headers,
    };

    try {
      return await axios.request<TResponse>({
        baseURL: AppData?.config?.login.endpoints.persona_url,
        url,
        method,
        headers,
        data: options?.data,
        params: options?.params,
        responseType: 'json',
      });
    } catch (e) {
      throw new ApiServiceError(e as AxiosError, url);
    }
  }
}
